<!-- components/Wrapper.vue -->
<template>
  <div class="home-wrapper">
    <!-- 固定 Header -->
    <div class="fixed-header">
      <Header />
    </div>

    <!-- 固定 Sidebar -->
    <div class="fixed-sidebar">
      <SideBar />
    </div>

    <!-- 固定 Footer -->
    <div class="fixed-footer">
      <Footer />
    </div>

    <!-- 主内容区 -->
    <div class="main-content">
      <slot />
    </div>
  </div>
</template>

<script setup>
import Header from '@/components/Header.vue'
import SideBar from '@/components/SideBar.vue'
import Footer from '@/components/Footer.vue'
</script>

<style scoped>
.home-wrapper {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  background-color: #f8f9fb;
  position: relative;
}

.fixed-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100px;
  background-color: #ffffff;
  border-bottom: 1px solid #e8e8e8;
  z-index: 1000;
}

.fixed-sidebar {
  position: fixed;
  top: 100px;
  left: 0;
  width: 200px;
  height: calc(100vh - 200px);
  background-color: #ffffff;
  border-right: 1px solid #e8e8e8;
  overflow-y: auto;
  z-index: 999;
}

.fixed-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100px;
  background-color: #ffffff;
  border-top: 1px solid #e8e8e8;
  z-index: 1000;
  padding-bottom: max(30px, env(safe-area-inset-bottom));
}

.main-content {
  margin-left: 200px;
  margin-top: 100px;
  margin-bottom: 100px;
  height: calc(100vh - 200px);
  padding: 24px;
  overflow-y: auto;
  background-color: #f8f9fb;
  box-sizing: border-box;
}
</style>